import { INSURANCE } from '@enums/Storefront'

export const getLottieForInsurance = (insuranceName: string) => {
  switch (insuranceName) {
    case INSURANCE.HEALTH_INSURANCE:
      return 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/health_Insurance_Lottie_f28fe9a335.json'
    case INSURANCE.TRAVEL_INSURANCE:
      return 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/travel_Insurance_Lottie_5ed93d130e.json'
    case INSURANCE.GIG_INSURANCE:
      return 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/gig_Insurance_Lottie_eaf8bb4bf4.json'
    case INSURANCE.ELECTRONICS_INSURANCE:
      return 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/electronics_Insurance_Lottie_cc5a13816e.json'
    default:
      return 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/health_Insurance_Lottie_f28fe9a335.json'
  }
}

export enum ContentViewType {
  ListView = 'list-view',
  CarousalStatic = 'carousal-static',
  CarousalAutoScroll = 'carousal-auto-scroll',
}

export enum ScrollType {
  AutoScroll = 'auto-scroll',
  Static = 'static',
}
